<script>
import { Doughnut, mixins } from 'vue-chartjs'
import { map, keys } from 'lodash'

export default {
  extends: Doughnut,

  mixins: [mixins.reactiveProp],

  data () {
    return {
      gradientBackground: null,
      gradientBackgroundBase: null,
      options: {
        cutoutPercentage: 85,
        animation: {
            // animateRotate: false,
        },
        elements: {
            center: {
                color: '#0074CB', //Default black
                fontStyle: "Roboto", //Default Arial
                sidePadding: 15 //Default 20 (as a percentage)
            }
        }
      }
    }
  },

  mounted () {
    this.addPlugin({
      id: 'my-plugin',
      beforeDraw: (chart) => {
        if (chart.config.options.elements.center) {
					//Get ctx from string
					var ctx = chart.chart.ctx;

					//Get options from the center object in options
					var centerConfig = chart.config.options.elements.center;
          var fontStyle = centerConfig.fontStyle || 'Arial';
          var txt = ''

          if (this.chartData.datasets.length > 0) {
            txt = `${Math.round(this.chartData.datasets[0].data[0])}%`;
          }

					var color = centerConfig.color || '#000';
					var sidePadding = centerConfig.sidePadding || 20;
					var sidePaddingCalculated = (sidePadding/100) * (chart.innerRadius * 2)
					//Start with a base font of 30px
					ctx.font = "45px " + fontStyle;

					//Get the width of the string and also the width of the element minus 10 to give it 5px side padding
					var stringWidth = ctx.measureText(txt).width;
					var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

					// Find out how much the font can grow in width.
					var widthRatio = elementWidth / stringWidth;
					var newFontSize = Math.floor(30 * widthRatio);
					var elementHeight = (chart.innerRadius * 2);

					// Pick a new font size so it will not be larger than the height of label.
					var fontSizeToUse = Math.min(newFontSize, elementHeight);

					//Set font settings to draw it correctly.
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
					var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2) + 2;
					ctx.font = "500 " + fontSizeToUse+"px " + fontStyle;
					ctx.fillStyle = color;

					//Draw text in center
					ctx.fillText(txt, centerX, centerY);
				}
      }
    })

    const ctx = this.$refs.canvas.getContext('2d')

    this.renderChart(this.chartData, this.options)
  }
}
</script>
